import axios from "axios";
import { post } from "util/requests";
import { useSelector, useDispatch } from "react-redux";
import { addFiles, refreshFileList } from "redux/files/actions";
import { corelab_api_url } from "config";
import { getToken } from "util/auth";

export const cancelRequests = (worker) => {
  worker.postMessage({ type: "cancel_requests" });
};

export const handleFileUpload = (dispatch, selectedFile, setProgress, subject_id = null, worker, study_id) => {
  let filename = selectedFile.name;
  let location_uuid = selectedFile.location_uuid;
  subject_id = selectedFile.subject_id;

  const chunkSize = 5 * 1024 * 1024; // 5MB (adjust based on your requirements)
  const totalChunks = Math.ceil(selectedFile.size / chunkSize);
  const size = selectedFile.size;

  post(`${corelab_api_url}/init_upload`, { filename, totalChunks })
    .then(({ data: { urls, Key, UploadId, new_uuid } }) => {
      worker.postMessage({
        type: "start_upload",
        selectedFile,
        filename,
        location_uuid,
        subject_id,
        corelab_api_url,
        Key,
        urls,
        UploadId,
        new_uuid,
        size,
        study_id,
      });
    })
    .catch((err) => {});

  worker.onmessage = (e) => {
    const { type } = e.data;
    if (type === "update") {
      const { filename, percent_complete, UploadId, queue, Key, new_uuid, location_uuid, subject_id, size, study_id } =
        e.data;
      // worker.terminate();

      if (percent_complete === 100) {
        if (UploadId) {
          post(`${corelab_api_url}/finalize_upload`, {
            UploadId,
            queue,
            Key,
            filename,
            size,
            location_uuid,
            new_uuid,
            subject_id,
            study_id,
          }).then(() => {
            dispatch(refreshFileList());
            setProgress(filename, 100);
          });
        }
      } else {
        setProgress(filename, percent_complete);
      }
    } else if (type === "cancel") {
      const { Key, UploadId } = e.data;
      post(`${corelab_api_url}/cancel_upload_s3`, {
        Key,
        UploadId,
      });
    }
  };
};

export const handleFileAddedToQueue = (dispatch, event, location_uuid, subject_id, replace = false) => {
  if (!global.files) {
    global.files = {};
  }
  const files = Array.from(event.target.files);

  files.forEach((file) => {
    file.percentage = 0;
    file.location_uuid = location_uuid;
    file.subject_id = subject_id;
    global.files[file.name] = file;
  });
  const dispatch_payload = files.map((file) => ({
    name: file.name,
    percentage: 0,
    location_uuid,
    replace,
    size: file.size,
    uploading: false,
  }));

  dispatch(addFiles(dispatch_payload));
};
